/**
 * 원리 보기(SR-PHY-07) 모양 · 색 · 크기 규칙 — three 없이(셸이 첫 번들에서 범례 색을 쓴다). 오버레이 구현은 ./principle.
 */

type V3 = readonly [number, number, number];

/** C-05 PrincipleMachine 과 같은 모양(구조적) */
export interface PrincipleMachineLike {
  readonly owner: string;
  readonly com: V3 | null;
  readonly massKg: number;
  readonly joints: readonly {
    readonly id: string;
    readonly port: string | null;
    readonly kind: "turn" | "slide";
    readonly at: V3;
    readonly axis: V3;
    readonly rate: number;
  }[];
  readonly wheels: readonly {
    readonly id: string;
    readonly port: string | null;
    readonly at: V3;
    readonly axis: V3;
    readonly spin: number;
    readonly torque: number;
  }[];
  readonly contacts: readonly { readonly body: string; readonly at: V3; readonly force: V3 }[];
}

export type PrincipleLabelKind = "joint" | "torque" | "force" | "weight";

/** 수치 라벨 하나(월드 m) — 풀 객체(값만 바뀐다) */
export interface PrincipleLabel {
  kind: PrincipleLabelKind;
  text: string;
  x: number;
  y: number;
  z: number;
}

/** 크기 규칙(m) — 시험 · 조정용 */
export const PRINCIPLE_SCALE = {
  /** 힘 1N → 화살표 길이(m) · 최소 · 최대 */
  forcePerN: 0.015,
  forceMin: 0.02,
  forceMax: 0.3,
  /** 이 힘(N) 아래 반력은 그리지 않는다 */
  forceHide: 0.05,
  /** 관절 굽은 화살표 반지름(m) · 이 각속도(도/s) 아래는 멈춘 것으로 본다 */
  jointRadius: 0.028,
  jointHide: 3,
  /** 그림 회전 속도 = 실제 각속도 × 이 값(빠른 기어도 눈으로 따라가게) */
  jointSpin: 0.5,
  /** 이동 관절 1 m/s → 화살표 길이 */
  slidePerMps: 1.5,
  /** 토크 화살표 반지름 = min + (|τ| ÷ full) × span · 이 토크(N·m) 아래는 그리지 않는다 */
  torqueMin: 0.025,
  torqueSpan: 0.05,
  torqueFull: 0.18,
  torqueHide: 0.0005,
  comRadius: 0.012,
} as const;

export const PRINCIPLE_COLORS = {
  joint: "#FFC845",
  torque: "#F2994A",
  force: "#2F80ED",
  weight: "#9B51E0",
  com: "#1F2A24",
} as const;

/** 화면 라벨(캔버스 CSS px) — 뷰의 principleLabels(out) 가 다시 쓴다 */
export interface PrincipleScreenLabel {
  kind: PrincipleLabelKind;
  text: string;
  x: number;
  y: number;
}
